import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { CreateTourExpenseRequestDto } from '@/features/dashboard/expenses/types/ExpenseRequest.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

export default function useCreateExpense() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateTourExpenseRequestDto) => expensesApi.create(dto),
    onSuccess: (_data, dto) => {
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.byTourId(dto.tourId),
      });
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.global(),
      });
      queryClient.invalidateQueries({
        queryKey: tourDashboardApiQueryKeys.finance(dto.tourId),
      });
      void invalidateAttentionQueries(queryClient, dto.tourId);
      toast.success('Wydatek został zaplanowany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas tworzenia wydatku.',
      });
    },
  });
}
